import { CheckoutPaymentTypes } from '../checkout/checkout-payment-types.interface';
import { CheckoutPricing } from './checkout-pricing.interface';

export interface CheckoutContractAttributes {
  productVariantId: string;
  subscription?: CheckoutPaymentTypes;
  annualPrepay?: CheckoutPaymentTypes;
  cc?: CheckoutPricing;
  ach?: CheckoutPricing;
  periodOfCover?: number;
  levelOfCoverCode?: string;
  effectiveDate?: string;
  thirdPartyContractExpiryDate?: string;
}
